import { createSlice } from '@reduxjs/toolkit';
import {
  API_OVERTURE_SETTINGS,
  API_OVERTURE_UPDATE_THRESHOLD,
  API_OVERTURE_REBUILD,
  API_OVERTURE_REBUILD_STATUS,
} from '../constants/index';

// ─── Action creators ────────────────────────────────────────────────────────
// Each returns a plain object intercepted by reduxApiMiddleware.
// The middleware returns Promise.resolve(res.data) so callers can use .then()

export const getOvertureSettings = () => ({
  type: 'API',
  payload: {
    url: API_OVERTURE_SETTINGS,
    method: 'GET',
    hideLoader: false,
  },
});

export const updateOvertureThreshold = (threshold) => ({
  type: 'API',
  payload: {
    url: API_OVERTURE_UPDATE_THRESHOLD,
    method: 'POST',
    data: { threshold },
    hideLoader: false,
  },
});

export const triggerOvertureRebuild = () => ({
  type: 'API',
  payload: {
    url: API_OVERTURE_REBUILD,
    method: 'POST',
    hideLoader: false,
  },
});

// hideLoader defaults to true — this is also used for background polling,
// which should never flash the global spinner every few seconds.
export const getOvertureRebuildStatus = ({ hideLoader = true } = {}) => ({
  type: 'API',
  payload: {
    url: API_OVERTURE_REBUILD_STATUS,
    method: 'GET',
    hideLoader,
  },
});

// ─── Slice (components manage their own state via .then()) ──────────────────
const OvertureSlice = createSlice({
  name: 'overture',
  initialState: {},
  reducers: {},
});

export default OvertureSlice.reducer;
